// File Metadata:
// Filename: EditReception.js
// Version: 1.00
// Created: 2022-09-28 22:17:54
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useParams } from 'react-router-dom'
import EditReceptionForm from './EditReceptionForm'
import { useGetReceptionsQuery } from '../api/receptionsApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import { useGetVendorsQuery } from '../api/vendorsApiSlice'
import QualityAssessmentForm from './QualityAssessment/QualityAssessmentForm'
import { Tabs, Tab, Box, Container } from '@mui/material'
import { useState } from 'react'

const EditReception = () => {
	const { id } = useParams()
	const { username, isVoorman, isAdmin } = useAuth()
	const [tab, setTab] = useState(0)

	const { reception } = useGetReceptionsQuery('receptionsList', {
		selectFromResult: ({ data }) => ({
			reception: data?.entities[id]
		})
	})
	const { vendors } = useGetVendorsQuery('vendorsList', {
		selectFromResult: ({ data }) => ({
			vendors: data?.ids.map(id => data?.entities[id])
		})
	})

	if (!reception || !vendors?.length) return <PulseLoader color='#fff' />

	if (!isVoorman && !isAdmin) {
		if (reception.username !== username) {
			return <p className='errmsg'>No access</p>
		}
	}
	const content = (
		<Container maxWidth="lg">
			<Box sx={{ width: '100%', mb: 2 }}>
				<Tabs value={tab} onChange={(e, v) => setTab(v)}>
					<Tab label="Details" />
					<Tab label="Quality Assessment" />
				</Tabs>
			</Box>

			<Box sx={{ maxWidth: '100%' }}>
				{tab === 0 && <EditReceptionForm reception={reception} vendors={vendors} />}
				{tab === 1 && <QualityAssessmentForm reception={reception} />}
			</Box>
		</Container>
	)

	return content
}

export default EditReception
